import React, { useMemo, useRef, useState } from 'react';
import { FilterChip } from './MetaNav';
import useUserSearch, { userDisplayName } from '../hooks/useUserSearch';

export default function UserFilterChip({ options, activeValues, onApply, scope = null }) {
    const [query, setQuery] = useState('');
    const { records, pending } = useUserSearch(query, { scope });
    const displayByValue = useRef(new Map());

    const remoteOptions = useMemo(
        () =>
            records.map((r) => {
                const email = (r.email || '').toLowerCase();
                const name = userDisplayName(r);
                displayByValue.current.set(email || name, name);
                return { label: email ? `${name} (${email})` : name, value: email || name, display: name };
            }),
        [records]
    );

    return (
        <FilterChip
            label="User"
            searchPlaceholder="Search users"
            options={options}
            activeValues={activeValues}
            onApply={(args) => onApply({ ...args, displayOf: (v) => displayByValue.current.get(v) })}
            onQueryChange={setQuery}
            remoteOptions={remoteOptions}
            remotePending={pending}
        />
    );
}
